import { DocumentTypes } from '@/ts/store/Constants';
import { CarbonDateTime } from './HococoInterfaces';

export default class DocumentsData {
    public id: number;
    public type: string;
    public title: string;
    public requiresSignature: boolean;
    public isSigned: boolean;
    public deadline: string;
    public processed: boolean;
    public read: boolean = false;
    public source: string;
    public createdAt: CarbonDateTime | any;
    public updatedAt: CarbonDateTime | any;
    public signatures: any;
    public translations: any;
    public categories: any;
    public media: any = [];
    public projects: any[];
    public buildings: any[];
    public variants: any[];
    public properties: any[];

    constructor(
        id: number,
        type: string = '',
        title: string = '',
        requiresSignature: boolean = false,
        isSigned: boolean = false,
        deadline?: string,
        processed: boolean = false,
        read: boolean = false,
        source: string = '',
        createdAt: CarbonDateTime | any = null,
        updatedAt: CarbonDateTime | any = null,
        signatures: any = [],
        translations: any = [],
        categories: any = [],
        media: any = [],
        projects: any = [],
        buildings: any = [],
        variants: any = [],
        properties: any = [],
    ) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.requiresSignature = requiresSignature;
        this.isSigned = isSigned;
        this.deadline = deadline;
        this.processed = processed;
        this.read = read;
        this.source = source;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.signatures = signatures;
        this.translations = translations;
        this.categories = categories;
        this.media = media;
        this.projects = projects;
        this.buildings = buildings;
        this.variants = variants;
        this.properties = properties;
    }

    public isContract() {
        return this.type === DocumentTypes.CONTRACT;
    }

    public isAttachment() {
        return this.type === DocumentTypes.DOCUMENT;
    }

    public isDocument() {
        return this.type === DocumentTypes.DOCUMENT;
    }

    public isSignedContract() {
        return this.type === DocumentTypes.CONTRACT && this.isSigned;
    }

    public isPendingContract() {
        return this.type === DocumentTypes.CONTRACT && !this.isSigned;
    }

    get signatureDate() {
        return  this.signatures.length ? this.signatures[0].created_at : new Date();
    }

    get sortingCriterion() {
        return typeof this.updatedAt.date === 'undefined' ? this.updatedAt : this.updatedAt.date;
    }    

    public isUnread() {
        return !this.read;
    }

    public propertiesSource(type: string) {
        let source = '';

        switch (type) {
            case 'properties':
                source = this.properties.length > 1 ? `${this.properties.length}` : `${this.properties[0].name}`;
                break;
            case 'variants':
                source = this.variants.length > 1 ? `${this.variants.length}` : `${this.variants[0].name}`;
                break;
            case 'buildings':
                source = this.buildings.length > 1 ? `${this.buildings.length}` : `${this.buildings[0].name}`;
                break;
            case 'projects':
                source = this.projects.length > 1 ? `${this.projects.length}` : `${this.projects[0].name}`;
                break;
        }

        return source;
    }
}
